export default {
	NODE_WIDTH: 320,
	NODE_HEIGHT: 64,
	LEAF_SPACING: 16,
	BRANCH_SPACING: 48,
	rootPosition: { x: 80, y: 16 },
	snapGrid: [8, 8] as [number, number],
	defaultViewport: { x: 0, y: 0, zoom: 1 }
};
